import { REACT_APP_API_URL } from "../configs/config";
import queryString from "query-string";

const getIaps = async (payload) => {
  const { appIds, platform, deviceId, userName, pageIndex, pageSize, status } =
    payload;

  // const params = new URLSearchParams();
  // params.append("status", status.join(","));
  // params.append("platforms", platform.join(","));
  // params.append("deviceId", deviceId);
  // params.append("userName", userName);
  // params.append("pageIndex", pageIndex);
  // params.append("pageSize", pageSize);

  // let query = `?pageIndex=${Number(pageIndex)}&pageSize=${Number(pageSize)}`;
  const appIdsMap = Array.isArray(appIds)
    ? appIds.map((row) => row.value)
    : appIds;
  console.log("statusMap", appIdsMap);
  const statusMap = Array.isArray(status)
    ? status.map((row) => row.value)
    : status;
  console.log("statusMap", statusMap);
  const platformMap = Array.isArray(platform)
    ? platform.map((row) => row.value)
    : platform;
  console.log("platformMap", platformMap);
  // query += searchQuery({
  //   status: statusMap,
  //   platform: platformMap,
  //   userName,
  //   deviceId,
  // });
  const queryParams = {
    appId: appIdsMap && appIdsMap.map(String),
    status: statusMap && statusMap.map(String),
    platform: platformMap && platformMap,
    userName,
    deviceId,
    pageIndex,
    pageSize,
  };
  console.log("queryParams", queryString.stringify(queryParams));
  console.log(
    "React Url",
    `${REACT_APP_API_URL}iap/search?${queryString.stringify(queryParams)}`
  );
  const response = await fetch(
    `${REACT_APP_API_URL}iap/search?${queryString.stringify(queryParams)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
  const reponseJson = await response.json();
  return reponseJson;
};

const deleteIap = async (payload) => {
  const response = await fetch(`${REACT_APP_API_URL}iap/delete`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${payload.token}`,
    },
    body: JSON.stringify(payload),
  });
  const reponseJson = await response.json();
  return reponseJson;
};

export { getIaps, deleteIap };
